import { getAssetName } from "@syla/shared/helpers/assets/getAssetName";
import { getAssetShortName } from "@syla/shared/helpers/assets/getAssetShortName";
import {
  GetAccountAssetsResponse,
  AssetDetail,
} from "@syla/shared/types/responses/GetAccountAssetsResponse";
import { UseQueryOptions } from "react-query/types/react/types";
import { StandardSelectOption } from "../components/selector/parts/SelectOption";
import missingImageIcon from "../images/thumbnails/missingImageIcon.svg";
import { useQueryAccountAssets } from "./useQueryAccountAssets";

// query for this user's assets
export const useQueryAccountAssetOptions = <TQueryFnData, TError = unknown>(
  accountId: string,
  options?: Omit<
    UseQueryOptions<GetAccountAssetsResponse, TError, StandardSelectOption[]>,
    "queryKey" | "queryFn"
  >,
) =>
  useQueryAccountAssets<TQueryFnData, TError, StandardSelectOption[]>(
    accountId,
    {
      select,
      ...options,
    },
  );

// ensure select function is outside the hook so it's reference is stable
const select = (assets: GetAccountAssetsResponse): StandardSelectOption[] =>
  assets.map(formatAssetOption);

export const formatAssetOption = (asset: AssetDetail): StandardSelectOption => {
  const label = getAssetShortName(asset);
  const description = getAssetName(asset);
  return {
    value: asset._id,
    keywords: [label, description],
    tooltip: getAssetName(asset),
    data: {
      label,
      description,
      icon: asset.image ?? missingImageIcon,
    },
  };
};
